import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import AppRoutes from './app.routes';

import ErrorBoundaryComp from './components/error-boundary.comp';

import store, { persistor } from './store/store';
import { QueryClientProvider } from '@tanstack/react-query';

import './app.css';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './i18n';
import { createAppQueryClient } from './query-client';

const queryClient = createAppQueryClient();

function App() {
  const [isReverse, setIsReverse] = useState(false);
  const { i18n } = useTranslation();

  useEffect(() => {
    setIsReverse(i18n.language === 'he');
  }, [i18n.language]);
  return (
    <ErrorBoundaryComp>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={null}>
            <Router>
              <AppRoutes />
            </Router>
          </PersistGate>
        </Provider>
      </QueryClientProvider>
    </ErrorBoundaryComp>
  );
}

export default App;
